// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "li[data-v-eed50a5c]:hover{text-decoration:underline;cursor:pointer;background-color:hsla(0,0%,80%,.3137254902);border-radius:4px}", ""]);
// Exports
module.exports = exports;
